/** Evita limpiar el detalle de cliente al abrir pantallas del Shell (p. ej. Detalle de venta). */
let preserveCustomerDetailOnce = false;

export function preserveCustomerDetailForShellNavigation(): void {
  preserveCustomerDetailOnce = true;
}

export function consumePreserveCustomerDetail(): boolean {
  if (!preserveCustomerDetailOnce) return false;
  preserveCustomerDetailOnce = false;
  return true;
}
